module.exports = {
      id: "blackshare-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-fa9bd75c1e834befd19aa957a85e34e1.svg#blackshare",
      toString: function () {
        return this.url;
      }
    }